module.exports = __webpack_public_path__ + "img/news8-4.41949830.png";